import { styled } from "@mui/material";

export const FileUploaderContainer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;
